import React from "react";
import AgHubHeader from "../components/Header/AgHubHeader";
import { Box, useMediaQuery, Typography } from "@mui/material";
import LoginBanner from "../components/SignIn/LoginBanner";
import Footer from "../components/Footer/Footer";
import LoginCards from "../components/SignIn/LoginCards";
import MobileView from "../components/SignIn/MobileView";

const SignIn = () => {
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down(899));

  return (
    <>
      {isSmallScreen ? (
        <MobileView />
      ) : (
        <Box
          sx={{
            minHeight: "100vh",
            display: "flex",
            flexDirection: "column",
            backgroundColor: "#EFF5FC",
            flexShrink: 0,
            justifyContent: "center",
            gap: "24px",
          }}
        >
          {/* Header */}
          <AgHubHeader />

          <main
            style={{ flex: 1 }}
            className="flex flex-row justify-center items-center gap-4"
          >
            <LoginBanner />
            <LoginCards />
          </main>

          {/* Footer */}
          <Footer />
        </Box>
      )}
    </>
  );
};

export default SignIn;
